/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CallNotificationPagedList } from '../models/call-notification-paged-list';
import { createEnedisConnectionConfiguration } from '../fn/enedis-connection/create-enedis-connection-configuration';
import { CreateEnedisConnectionConfiguration$Params } from '../fn/enedis-connection/create-enedis-connection-configuration';
import { createGrdfConnectionConfiguration } from '../fn/grdf-connection/create-grdf-connection-configuration';
import { CreateGrdfConnectionConfiguration$Params } from '../fn/grdf-connection/create-grdf-connection-configuration';
import { createOpcuaConfiguration } from '../fn/opcua-connection/create-opcua-configuration';
import { CreateOpcuaConfiguration$Params } from '../fn/opcua-connection/create-opcua-configuration';
import { createStation } from '../fn/sites-management/create-station';
import { CreateStation$Params } from '../fn/sites-management/create-station';
import { deleteStation } from '../fn/sites-management/delete-station';
import { DeleteStation$Params } from '../fn/sites-management/delete-station';
import { EnedisConnectionConfig } from '../models/enedis-connection-config';
import { EnedisConnectionConfigList } from '../models/enedis-connection-config-list';
import { exportConnectionTagsOpcuaDefinition } from '../fn/opcua-connection/export-connection-tags-opcua-definition';
import { ExportConnectionTagsOpcuaDefinition$Params } from '../fn/opcua-connection/export-connection-tags-opcua-definition';
import { exportConnectionTagsSmsDefinition } from '../fn/sms-connection/export-connection-tags-sms-definition';
import { ExportConnectionTagsSmsDefinition$Params } from '../fn/sms-connection/export-connection-tags-sms-definition';
import { exportEnedisConnectionTags } from '../fn/enedis-connection/export-enedis-connection-tags';
import { ExportEnedisConnectionTags$Params } from '../fn/enedis-connection/export-enedis-connection-tags';
import { exportGrdfConnectionTags } from '../fn/grdf-connection/export-grdf-connection-tags';
import { ExportGrdfConnectionTags$Params } from '../fn/grdf-connection/export-grdf-connection-tags';
import { exportStationDefinition } from '../fn/sites-management/export-station-definition';
import { ExportStationDefinition$Params } from '../fn/sites-management/export-station-definition';
import { exportStationTransactions } from '../fn/transactions/export-station-transactions';
import { ExportStationTransactions$Params } from '../fn/transactions/export-station-transactions';
import { getEnedisConnectionConfigurations } from '../fn/enedis-connection/get-enedis-connection-configurations';
import { GetEnedisConnectionConfigurations$Params } from '../fn/enedis-connection/get-enedis-connection-configurations';
import { getGrdfConnectionConfigurations } from '../fn/grdf-connection/get-grdf-connection-configurations';
import { GetGrdfConnectionConfigurations$Params } from '../fn/grdf-connection/get-grdf-connection-configurations';
import { getOpcuaConfiguration } from '../fn/opcua-connection/get-opcua-configuration';
import { GetOpcuaConfiguration$Params } from '../fn/opcua-connection/get-opcua-configuration';
import { getOpcuaConfigurationTagsValues } from '../fn/opcua-connection/get-opcua-configuration-tags-values';
import { GetOpcuaConfigurationTagsValues$Params } from '../fn/opcua-connection/get-opcua-configuration-tags-values';
import { getStation } from '../fn/sites-management/get-station';
import { GetStation$Params } from '../fn/sites-management/get-station';
import { getStationNumericsTags } from '../fn/sites-management/get-station-numerics-tags';
import { GetStationNumericsTags$Params } from '../fn/sites-management/get-station-numerics-tags';
import { getTicketsStations } from '../fn/sites-management/get-tickets-stations';
import { GetTicketsStations$Params } from '../fn/sites-management/get-tickets-stations';
import { GrdfConnectionConfig } from '../models/grdf-connection-config';
import { GrdfConnectionConfigList } from '../models/grdf-connection-config-list';
import { importConfigurationSmsTagsDefinition } from '../fn/sms-connection/import-configuration-sms-tags-definition';
import { ImportConfigurationSmsTagsDefinition$Params } from '../fn/sms-connection/import-configuration-sms-tags-definition';
import { importConnectionTagsOpcuaDefinition } from '../fn/opcua-connection/import-connection-tags-opcua-definition';
import { ImportConnectionTagsOpcuaDefinition$Params } from '../fn/opcua-connection/import-connection-tags-opcua-definition';
import { importEnedisConnectionTags } from '../fn/enedis-connection/import-enedis-connection-tags';
import { ImportEnedisConnectionTags$Params } from '../fn/enedis-connection/import-enedis-connection-tags';
import { importGrdfConnectionTags } from '../fn/grdf-connection/import-grdf-connection-tags';
import { ImportGrdfConnectionTags$Params } from '../fn/grdf-connection/import-grdf-connection-tags';
import { importStationDefinition } from '../fn/sites-management/import-station-definition';
import { ImportStationDefinition$Params } from '../fn/sites-management/import-station-definition';
import { listEnedisConnectionConfigurations } from '../fn/enedis-connection/list-enedis-connection-configurations';
import { ListEnedisConnectionConfigurations$Params } from '../fn/enedis-connection/list-enedis-connection-configurations';
import { listGrdfConnectionConfigurations } from '../fn/grdf-connection/list-grdf-connection-configurations';
import { ListGrdfConnectionConfigurations$Params } from '../fn/grdf-connection/list-grdf-connection-configurations';
import { listOpcuaConfigurations } from '../fn/opcua-connection/list-opcua-configurations';
import { ListOpcuaConfigurations$Params } from '../fn/opcua-connection/list-opcua-configurations';
import { OpcuaConfig } from '../models/opcua-config';
import { OpcuaConfigList } from '../models/opcua-config-list';
import { removeEnedisConnectionConfiguration } from '../fn/enedis-connection/remove-enedis-connection-configuration';
import { RemoveEnedisConnectionConfiguration$Params } from '../fn/enedis-connection/remove-enedis-connection-configuration';
import { removeGrdfConnectionConfiguration } from '../fn/grdf-connection/remove-grdf-connection-configuration';
import { RemoveGrdfConnectionConfiguration$Params } from '../fn/grdf-connection/remove-grdf-connection-configuration';
import { removeOpcuaConfiguration } from '../fn/opcua-connection/remove-opcua-configuration';
import { RemoveOpcuaConfiguration$Params } from '../fn/opcua-connection/remove-opcua-configuration';
import { searchCallNotificationsByStation$Any } from '../fn/sites-management/search-call-notifications-by-station-any';
import { SearchCallNotificationsByStation$Any$Params } from '../fn/sites-management/search-call-notifications-by-station-any';
import { searchCallNotificationsByStation$Json } from '../fn/sites-management/search-call-notifications-by-station-json';
import { SearchCallNotificationsByStation$Json$Params } from '../fn/sites-management/search-call-notifications-by-station-json';
import { searchStations } from '../fn/sites-management/search-stations';
import { SearchStations$Params } from '../fn/sites-management/search-stations';
import { searchStationsFollowers } from '../fn/sites-management/search-stations-followers';
import { SearchStationsFollowers$Params } from '../fn/sites-management/search-stations-followers';
import { searchStationTags$Any } from '../fn/sites-management/search-station-tags-any';
import { SearchStationTags$Any$Params } from '../fn/sites-management/search-station-tags-any';
import { searchStationTags$Json } from '../fn/sites-management/search-station-tags-json';
import { SearchStationTags$Json$Params } from '../fn/sites-management/search-station-tags-json';
import { Station } from '../models/station';
import { StationFollowersList } from '../models/station-followers-list';
import { StationPagedList } from '../models/station-paged-list';
import { StationTicketsStats } from '../models/station-tickets-stats';
import { TagDisplayInfos } from '../models/tag-display-infos';
import { TagList } from '../models/tag-list';
import { TagsRealtimeDataLastValuesList } from '../models/tags-realtime-data-last-values-list';
import { updateEnedisConnectionConfiguration } from '../fn/enedis-connection/update-enedis-connection-configuration';
import { UpdateEnedisConnectionConfiguration$Params } from '../fn/enedis-connection/update-enedis-connection-configuration';
import { updateGrdfConnectionConfiguration } from '../fn/grdf-connection/update-grdf-connection-configuration';
import { UpdateGrdfConnectionConfiguration$Params } from '../fn/grdf-connection/update-grdf-connection-configuration';
import { updateOpcuaConfiguration } from '../fn/opcua-connection/update-opcua-configuration';
import { UpdateOpcuaConfiguration$Params } from '../fn/opcua-connection/update-opcua-configuration';
import { updateStation } from '../fn/sites-management/update-station';
import { UpdateStation$Params } from '../fn/sites-management/update-station';


/**
 * All about the sites configuration / management
 */
@Injectable({ providedIn: 'root' })
export class SitesManagementService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createStation()` */
  static readonly CreateStationPath = '/stations';

  /**
   * Create a generic station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStation$Response(params: CreateStation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a generic station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStation(params: CreateStation$Params, context?: HttpContext): Observable<void> {
    return this.createStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchStationsFollowers()` */
  static readonly SearchStationsFollowersPath = '/stations/followers/search';

  /**
   * Get a list of station followers from a list of station uids.
   *
   * Return a list of station followers from a list of station uids
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsFollowers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsFollowers$Response(params: SearchStationsFollowers$Params, context?: HttpContext): Observable<StrictHttpResponse<StationFollowersList>> {
    return searchStationsFollowers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a list of station followers from a list of station uids.
   *
   * Return a list of station followers from a list of station uids
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsFollowers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsFollowers(params: SearchStationsFollowers$Params, context?: HttpContext): Observable<StationFollowersList> {
    return this.searchStationsFollowers$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationFollowersList>): StationFollowersList => r.body)
    );
  }

  /** Path part for operation `searchStations()` */
  static readonly SearchStationsPath = '/stations/search';

  /**
   * Search stations, with pagination.
   *
   * Search stations, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStations()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchStations$Response(params?: SearchStations$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPagedList>> {
    return searchStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Search stations, with pagination.
   *
   * Search stations, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchStations(params?: SearchStations$Params, context?: HttpContext): Observable<StationPagedList> {
    return this.searchStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPagedList>): StationPagedList => r.body)
    );
  }

  /** Path part for operation `getTicketsStations()` */
  static readonly GetTicketsStationsPath = '/stations/tickets/stats';

  /**
   * Get tickets summary by station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicketsStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTicketsStations$Response(params: GetTicketsStations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StationTicketsStats>>> {
    return getTicketsStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get tickets summary by station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicketsStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTicketsStations(params: GetTicketsStations$Params, context?: HttpContext): Observable<Array<StationTicketsStats>> {
    return this.getTicketsStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StationTicketsStats>>): Array<StationTicketsStats> => r.body)
    );
  }

  /** Path part for operation `importStationDefinition()` */
  static readonly ImportStationDefinitionPath = '/stations/config/import';

  /**
   * Import the the Stations Definitionn.
   *
   * Allows to import the Stations Definition, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importStationDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationDefinition$Response(params?: ImportStationDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importStationDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the the Stations Definitionn.
   *
   * Allows to import the Stations Definition, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importStationDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationDefinition(params?: ImportStationDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importStationDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportStationDefinition()` */
  static readonly ExportStationDefinitionPath = '/stations/config/export';

  /**
   * Export the Stations Definition.
   *
   * Allows to export the the Stations Definition.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationDefinition$Response(params?: ExportStationDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the Stations Definition.
   *
   * Allows to export the the Stations Definition.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationDefinition(params?: ExportStationDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getStation()` */
  static readonly GetStationPath = '/stations/{uid}';

  /**
   * Retrieve a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStation$Response(params: GetStation$Params, context?: HttpContext): Observable<StrictHttpResponse<Station>> {
    return getStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStation(params: GetStation$Params, context?: HttpContext): Observable<Station> {
    return this.getStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<Station>): Station => r.body)
    );
  }

  /** Path part for operation `updateStation()` */
  static readonly UpdateStationPath = '/stations/{uid}';

  /**
   * Update a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStation$Response(params: UpdateStation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStation(params: UpdateStation$Params, context?: HttpContext): Observable<void> {
    return this.updateStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteStation()` */
  static readonly DeleteStationPath = '/stations/{uid}';

  /**
   * Delete a station (logical delete).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStation$Response(params: DeleteStation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a station (logical delete).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStation(params: DeleteStation$Params, context?: HttpContext): Observable<void> {
    return this.deleteStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchCallNotificationsByStation()` */
  static readonly SearchCallNotificationsByStationPath = '/stations/{uid}/notification/call/search';

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCallNotificationsByStation$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCallNotificationsByStation$Json$Response(params: SearchCallNotificationsByStation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationPagedList>> {
    return searchCallNotificationsByStation$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCallNotificationsByStation$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCallNotificationsByStation$Json(params: SearchCallNotificationsByStation$Json$Params, context?: HttpContext): Observable<CallNotificationPagedList> {
    return this.searchCallNotificationsByStation$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CallNotificationPagedList>): CallNotificationPagedList => r.body)
    );
  }

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCallNotificationsByStation$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCallNotificationsByStation$Any$Response(params: SearchCallNotificationsByStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationPagedList>> {
    return searchCallNotificationsByStation$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCallNotificationsByStation$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCallNotificationsByStation$Any(params: SearchCallNotificationsByStation$Any$Params, context?: HttpContext): Observable<CallNotificationPagedList> {
    return this.searchCallNotificationsByStation$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<CallNotificationPagedList>): CallNotificationPagedList => r.body)
    );
  }

  /** Path part for operation `searchStationTags()` */
  static readonly SearchStationTagsPath = '/stations/{uid}/tags/search';

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationTags$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationTags$Json$Response(params: SearchStationTags$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
    return searchStationTags$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationTags$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationTags$Json(params: SearchStationTags$Json$Params, context?: HttpContext): Observable<TagList> {
    return this.searchStationTags$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagList>): TagList => r.body)
    );
  }

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationTags$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationTags$Any$Response(params: SearchStationTags$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TagList>> {
    return searchStationTags$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags for the station.
   *
   * The tags for the station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationTags$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationTags$Any(params: SearchStationTags$Any$Params, context?: HttpContext): Observable<TagList> {
    return this.searchStationTags$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagList>): TagList => r.body)
    );
  }

  /** Path part for operation `getStationNumericsTags()` */
  static readonly GetStationNumericsTagsPath = '/stations/{uid}/tags/numeric';

  /**
   * Get the list of name and id of numerical tags for a station.
   *
   * Retrieve the station numerical tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationNumericsTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationNumericsTags$Response(params: GetStationNumericsTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagDisplayInfos>>> {
    return getStationNumericsTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of name and id of numerical tags for a station.
   *
   * Retrieve the station numerical tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationNumericsTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationNumericsTags(params: GetStationNumericsTags$Params, context?: HttpContext): Observable<Array<TagDisplayInfos>> {
    return this.getStationNumericsTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TagDisplayInfos>>): Array<TagDisplayInfos> => r.body)
    );
  }

  /** Path part for operation `listOpcuaConfigurations()` */
  static readonly ListOpcuaConfigurationsPath = '/stations/{uid}/opcua';

  /**
   * List a station opcua configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOpcuaConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOpcuaConfigurations$Response(params: ListOpcuaConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<OpcuaConfigList>> {
    return listOpcuaConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station opcua configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOpcuaConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOpcuaConfigurations(params: ListOpcuaConfigurations$Params, context?: HttpContext): Observable<OpcuaConfigList> {
    return this.listOpcuaConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpcuaConfigList>): OpcuaConfigList => r.body)
    );
  }

  /** Path part for operation `createOpcuaConfiguration()` */
  static readonly CreateOpcuaConfigurationPath = '/stations/{uid}/opcua';

  /**
   * Create a station opcua configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOpcuaConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOpcuaConfiguration$Response(params: CreateOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station opcua configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOpcuaConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOpcuaConfiguration(params: CreateOpcuaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOpcuaConfiguration()` */
  static readonly GetOpcuaConfigurationPath = '/stations/{uid}/opcua/{opcuaUid}';

  /**
   * Get a station opcua configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpcuaConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfiguration$Response(params: GetOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OpcuaConfig>> {
    return getOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station opcua configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOpcuaConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfiguration(params: GetOpcuaConfiguration$Params, context?: HttpContext): Observable<OpcuaConfig> {
    return this.getOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpcuaConfig>): OpcuaConfig => r.body)
    );
  }

  /** Path part for operation `updateOpcuaConfiguration()` */
  static readonly UpdateOpcuaConfigurationPath = '/stations/{uid}/opcua/{opcuaUid}';

  /**
   * update a station opcua configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOpcuaConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOpcuaConfiguration$Response(params: UpdateOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * update a station opcua configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOpcuaConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOpcuaConfiguration(params: UpdateOpcuaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeOpcuaConfiguration()` */
  static readonly RemoveOpcuaConfigurationPath = '/stations/{uid}/opcua/{opcuaUid}';

  /**
   * Remove the station opcua configuration.
   *
   * Remove Opcua configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeOpcuaConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOpcuaConfiguration$Response(params: RemoveOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station opcua configuration.
   *
   * Remove Opcua configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeOpcuaConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOpcuaConfiguration(params: RemoveOpcuaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOpcuaConfigurationTagsValues()` */
  static readonly GetOpcuaConfigurationTagsValuesPath = '/stations/{uid}/opcua/{opcuaUid}/tags';

  /**
   * Get a station opcua configuration tags and values.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpcuaConfigurationTagsValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfigurationTagsValues$Response(params: GetOpcuaConfigurationTagsValues$Params, context?: HttpContext): Observable<StrictHttpResponse<TagsRealtimeDataLastValuesList>> {
    return getOpcuaConfigurationTagsValues(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station opcua configuration tags and values.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOpcuaConfigurationTagsValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfigurationTagsValues(params: GetOpcuaConfigurationTagsValues$Params, context?: HttpContext): Observable<TagsRealtimeDataLastValuesList> {
    return this.getOpcuaConfigurationTagsValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagsRealtimeDataLastValuesList>): TagsRealtimeDataLastValuesList => r.body)
    );
  }

  /** Path part for operation `exportConnectionTagsOpcuaDefinition()` */
  static readonly ExportConnectionTagsOpcuaDefinitionPath = '/stations/{uid}/opcua/configuration/{opcuaUid}/export';

  /**
   * Export the OPCUA tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsOpcuaDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsOpcuaDefinition$Response(params: ExportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsOpcuaDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the OPCUA tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsOpcuaDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsOpcuaDefinition(params: ExportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsOpcuaDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importConnectionTagsOpcuaDefinition()` */
  static readonly ImportConnectionTagsOpcuaDefinitionPath = '/stations/{uid}/opcua/configuration/{opcuaUid}/import';

  /**
   * Import the OPCUA tags definitions for a connection.
   *
   * Allows to import the OPCUA tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConnectionTagsOpcuaDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsOpcuaDefinition$Response(params: ImportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConnectionTagsOpcuaDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the OPCUA tags definitions for a connection.
   *
   * Allows to import the OPCUA tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConnectionTagsOpcuaDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsOpcuaDefinition(params: ImportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConnectionTagsOpcuaDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportConnectionTagsSmsDefinition()` */
  static readonly ExportConnectionTagsSmsDefinitionPath = '/stations/{uid}/sms/configuration/{smsUid}/export';

  /**
   * Export the SMS tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid smsUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsSmsDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsSmsDefinition$Response(params: ExportConnectionTagsSmsDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsSmsDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the SMS tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid smsUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsSmsDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsSmsDefinition(params: ExportConnectionTagsSmsDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsSmsDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importConfigurationSmsTagsDefinition()` */
  static readonly ImportConfigurationSmsTagsDefinitionPath = '/stations/{uid}/sms/configuration/{smsUid}/import';

  /**
   * Import the SMS tags definitions for a connection.
   *
   * Allows to import the SMS tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConfigurationSmsTagsDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConfigurationSmsTagsDefinition$Response(params: ImportConfigurationSmsTagsDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConfigurationSmsTagsDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the SMS tags definitions for a connection.
   *
   * Allows to import the SMS tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConfigurationSmsTagsDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConfigurationSmsTagsDefinition(params: ImportConfigurationSmsTagsDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConfigurationSmsTagsDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listEnedisConnectionConfigurations()` */
  static readonly ListEnedisConnectionConfigurationsPath = '/stations/{uid}/enedis';

  /**
   * List a station Enedis connections configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEnedisConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEnedisConnectionConfigurations$Response(params: ListEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionConfigList>> {
    return listEnedisConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station Enedis connections configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEnedisConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEnedisConnectionConfigurations(params: ListEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<EnedisConnectionConfigList> {
    return this.listEnedisConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisConnectionConfigList>): EnedisConnectionConfigList => r.body)
    );
  }

  /** Path part for operation `createEnedisConnectionConfiguration()` */
  static readonly CreateEnedisConnectionConfigurationPath = '/stations/{uid}/enedis';

  /**
   * Create a station Enedis connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEnedisConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEnedisConnectionConfiguration$Response(params: CreateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createEnedisConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station Enedis connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEnedisConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEnedisConnectionConfiguration(params: CreateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createEnedisConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEnedisConnectionConfigurations()` */
  static readonly GetEnedisConnectionConfigurationsPath = '/stations/{uid}/enedis/{enedisUid}';

  /**
   * Get a station Enedis connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnedisConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisConnectionConfigurations$Response(params: GetEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<EnedisConnectionConfig>> {
    return getEnedisConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station Enedis connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEnedisConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnedisConnectionConfigurations(params: GetEnedisConnectionConfigurations$Params, context?: HttpContext): Observable<EnedisConnectionConfig> {
    return this.getEnedisConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnedisConnectionConfig>): EnedisConnectionConfig => r.body)
    );
  }

  /** Path part for operation `updateEnedisConnectionConfiguration()` */
  static readonly UpdateEnedisConnectionConfigurationPath = '/stations/{uid}/enedis/{enedisUid}';

  /**
   * Update a station Enedis connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEnedisConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEnedisConnectionConfiguration$Response(params: UpdateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEnedisConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a station Enedis connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEnedisConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEnedisConnectionConfiguration(params: UpdateEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateEnedisConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeEnedisConnectionConfiguration()` */
  static readonly RemoveEnedisConnectionConfigurationPath = '/stations/{uid}/enedis/{enedisUid}';

  /**
   * Remove the station Enedis connection configuration.
   *
   * Remove Enedis connection configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeEnedisConnectionConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeEnedisConnectionConfiguration$Response(params: RemoveEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeEnedisConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station Enedis connection configuration.
   *
   * Remove Enedis connection configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeEnedisConnectionConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeEnedisConnectionConfiguration(params: RemoveEnedisConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeEnedisConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportEnedisConnectionTags()` */
  static readonly ExportEnedisConnectionTagsPath = '/stations/{uid}/enedis/configuration/{enedisUid}/export';

  /**
   * Export the tags of the Enedis connection of a station.
   *
   * Allows to export the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEnedisConnectionTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEnedisConnectionTags$Response(params: ExportEnedisConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportEnedisConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the tags of the Enedis connection of a station.
   *
   * Allows to export the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportEnedisConnectionTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEnedisConnectionTags(params: ExportEnedisConnectionTags$Params, context?: HttpContext): Observable<Blob> {
    return this.exportEnedisConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importEnedisConnectionTags()` */
  static readonly ImportEnedisConnectionTagsPath = '/stations/{uid}/enedis/configuration/{enedisUid}/import';

  /**
   * Import and create the tags of the Enedis connection of a station.
   *
   * Allows to import and create the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importEnedisConnectionTags()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importEnedisConnectionTags$Response(params: ImportEnedisConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importEnedisConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Import and create the tags of the Enedis connection of a station.
   *
   * Allows to import and create the tags of the Enedis connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importEnedisConnectionTags$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importEnedisConnectionTags(params: ImportEnedisConnectionTags$Params, context?: HttpContext): Observable<void> {
    return this.importEnedisConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listGrdfConnectionConfigurations()` */
  static readonly ListGrdfConnectionConfigurationsPath = '/stations/{uid}/grdf';

  /**
   * List a station GRDF connections configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGrdfConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGrdfConnectionConfigurations$Response(params: ListGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GrdfConnectionConfigList>> {
    return listGrdfConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station GRDF connections configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGrdfConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGrdfConnectionConfigurations(params: ListGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<GrdfConnectionConfigList> {
    return this.listGrdfConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<GrdfConnectionConfigList>): GrdfConnectionConfigList => r.body)
    );
  }

  /** Path part for operation `createGrdfConnectionConfiguration()` */
  static readonly CreateGrdfConnectionConfigurationPath = '/stations/{uid}/grdf';

  /**
   * Create a station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGrdfConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGrdfConnectionConfiguration$Response(params: CreateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createGrdfConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createGrdfConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGrdfConnectionConfiguration(params: CreateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createGrdfConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getGrdfConnectionConfigurations()` */
  static readonly GetGrdfConnectionConfigurationsPath = '/stations/{uid}/grdf/{grdfUid}';

  /**
   * Get a station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGrdfConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrdfConnectionConfigurations$Response(params: GetGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GrdfConnectionConfig>> {
    return getGrdfConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGrdfConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrdfConnectionConfigurations(params: GetGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<GrdfConnectionConfig> {
    return this.getGrdfConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<GrdfConnectionConfig>): GrdfConnectionConfig => r.body)
    );
  }

  /** Path part for operation `updateGrdfConnectionConfiguration()` */
  static readonly UpdateGrdfConnectionConfigurationPath = '/stations/{uid}/grdf/{grdfUid}';

  /**
   * Update a station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGrdfConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGrdfConnectionConfiguration$Response(params: UpdateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGrdfConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGrdfConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGrdfConnectionConfiguration(params: UpdateGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateGrdfConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeGrdfConnectionConfiguration()` */
  static readonly RemoveGrdfConnectionConfigurationPath = '/stations/{uid}/grdf/{grdfUid}';

  /**
   * Remove the station GRDF connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeGrdfConnectionConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGrdfConnectionConfiguration$Response(params: RemoveGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeGrdfConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station GRDF connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeGrdfConnectionConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGrdfConnectionConfiguration(params: RemoveGrdfConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeGrdfConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportGrdfConnectionTags()` */
  static readonly ExportGrdfConnectionTagsPath = '/stations/{uid}/grdf/configuration/{grdfUid}/export';

  /**
   * Export the tags of the GRDF connection of a station.
   *
   * Allows to export the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportGrdfConnectionTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportGrdfConnectionTags$Response(params: ExportGrdfConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportGrdfConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the tags of the GRDF connection of a station.
   *
   * Allows to export the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportGrdfConnectionTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportGrdfConnectionTags(params: ExportGrdfConnectionTags$Params, context?: HttpContext): Observable<Blob> {
    return this.exportGrdfConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importGrdfConnectionTags()` */
  static readonly ImportGrdfConnectionTagsPath = '/stations/{uid}/grdf/configuration/{grdfUid}/import';

  /**
   * Import and create the tags of the GRDF connection of a station.
   *
   * Allows to import and create the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importGrdfConnectionTags()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importGrdfConnectionTags$Response(params: ImportGrdfConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importGrdfConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Import and create the tags of the GRDF connection of a station.
   *
   * Allows to import and create the tags of the GRDF connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importGrdfConnectionTags$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importGrdfConnectionTags(params: ImportGrdfConnectionTags$Params, context?: HttpContext): Observable<void> {
    return this.importGrdfConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportStationTransactions()` */
  static readonly ExportStationTransactionsPath = '/stations/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactions$Response(params: ExportStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactions(params: ExportStationTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
